import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-task-schedule-by',
  templateUrl: './task-schedule-by.component.html',
  styleUrls: ['./task-schedule-by.component.scss']
})
export class TaskScheduleByComponent implements OnInit {

  selectedValue: Number = 2;

  @Output() closeAssignedTask = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void {
  }

  close(){
    this.closeAssignedTask.emit(false)
  }
}
